function supFractions($number, $force = true) {
    let decimalPart = Math.floor($number);
    let fractionPart = Number.parseFloat($number - decimalPart).toFixed(2).substring(2);

    if (fractionPart === '00') {
        if ($force === true) {
            fractionPart = '.<sup>'+fractionPart+'</sup>'
        } else {
            fractionPart = '';
        }
    } else {
        fractionPart = '.<sup>'+fractionPart+'</sup>'
    }

    return '$' + decimalPart + '' + fractionPart;
}


function errorState(state, field) {
    if (state.errors !== undefined && state.errors[field] !== undefined) {
        return 'has-error';
    }
    return '';
}


function startsWithVowel($string) {
    if (!$string.length) return false;
    return ['a', 'e', 'i', 'o', 'u'].indexOf($string.toLowerCase().charAt(0)) !== -1
}

function hasPrimeLocal($products) {
    return Object.keys($products).some((productType, i) => {
        return (productType === 'tv' && $products[productType] && $products[productType].title === 'Prime Local');
    });
}

export { supFractions, errorState, startsWithVowel, hasPrimeLocal };